import React from 'react';
import { cn } from '@kiiwi/ui';
import FontAwesomeIcon from '@/components/atoms/FontawesomeIcon/FontawesomeIcon';

type ProCardTLCIconProps = {
  className?: string;
};

const ProCardTLCIcon = ({ className }: ProCardTLCIconProps) => {
  return (
    <div className={cn('rounded-full bg-surface-white p-1', className)}>
      <FontAwesomeIcon
        name="video:solid"
        className="size-3 text-neutral-primary"
      />
    </div>
  );
};
export default ProCardTLCIcon;
